import * as React from 'react';
import { withLocalize, Translate } from "react-localize-redux";

import './Completed.css';

const url = require('url'); // built-in utility

interface ICompletedProps {
    
}

interface ICompletedState {
    
}

class Completed extends React.Component<ICompletedProps, ICompletedState> {
    constructor(props: ICompletedProps) {
        super(props);

        this.state = {
            
        };
    }

    onClickRestart = () => {
        window.location.replace(url.parse(window.location.href).pathname);
    }

    render() {
        return (
            <div className={'Completed'}>
                <div className={'Completed-message'}>
                    <Translate id="completed_js.completed_message"/>
                </div>
                <div className={'Completed-restart'} onClick={this.onClickRestart}>
                    <Translate id="completed_js.completed_restart"/>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <div className={'Completed-message'}>
                    <Translate id="completed_js.own_device"/>
                </div>
                <br></br>
                <div>
                    <a href={'https://youtu.be/CydlfstKmDw'} target={'_blank'} rel={'noopener noreferrer'}><Translate id={'completed_js.video_link_text'}/></a>
                </div>
            </div>
        );
    }
}

export default withLocalize(Completed);
// export default Completed;
